import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { isTokenExpired } from '@/services/betslip/_helpers/isTokenExpired';
import {BETSLIP_BASE_URL} from "@/services/betslip/_constants";
import store from "@/store";

export const signalRService = (function(){    
    function SignalRSingleton() {
        let authToken = null;
        const buildHub = (isLoggedIn, submitResponceCallback, logout) => {
            authToken = store.state.betslipStore.authToken
            if (!isLoggedIn || !authToken) {
                return {
                    isError: true,
                    error: 'Please log in to submit betslips',
                };
            }

            if (isTokenExpired(store.state.betslipStore.authTokenExpiredAt)) {
                return {
                    isToLogout: true,
                    isError: true,
                    error: 'Session is expired',
                };
            }

            try {
                const connect = new HubConnectionBuilder()
                    .withUrl(BETSLIP_BASE_URL + '/hubs/betslip', { accessTokenFactory: () => authToken })
                    .withAutomaticReconnect()
                    .configureLogging(LogLevel.Information)
                    .build();

                connect.onreconnecting(() => {
                    console.warn('Reconnecting to the websocket');
                    if (isTokenExpired(store.state.betslipStore.authTokenExpiredAt)) {
                        connect.stop();
                        logout();
                    }
                });
                connect.onreconnected(() => {
                    console.warn('Reconnected to the websocket');
                });
                connect.onclose(() => {
                    console.warn('Connection was closed');
                });

                connect.on('SubmitResponse', submitResponceCallback);

                connect.start()
                    .then(()=> {
                        console.warn('Connection established!');
                    })
                    .catch(err => {
                        console.error('signalr connecting error', err);
                        if (isTokenExpired(store.state.betslipStore.authTokenExpiredAt)) {
                            logout();
                        }
                    });

                return {
                    isError: false,
                    connect,
                };
            } catch (err) {
                console.error('build hub', err);
                return {
                    isError: true,
                    error: err.message || 'Cannot establish connection. Please try later',
                };
            }
        };
    
        return {
            buildHub,
        };
    }

    let instance = null;

    if (instance == null) {
        instance = new SignalRSingleton();

        // Hide the constructor so the returned object can't be new'd...
        instance.constructor = null;
    }
    return instance;
})();